import memoizeOne from 'memoize-one'
import * as PIXI from 'pixi.js'

import { Dimension } from '../../../layout/constants'
import { createDefaultStyle } from '../../../style/parser'
import textLayout from '../layout'
import tokenize, { registerTextRule } from '../tokenizer'
import { measureText } from '../utils'

import createTexture from './createTexture'

const defaultStyle = createDefaultStyle()

export default class Text extends PIXI.Sprite {
  constructor() {
    super()

    this.layout = { width: 0, height: 0 }
    this.resolution = 1
    this._text = null
    this.memoizedCreateTexture = memoizeOne(createTexture)
  }

  set text(value) {
    if (this._text === value) {
      return
    }

    this._text = value
    this.tokens = tokenize(value)
    for (let token of this.tokens) {
      token.setParent(this)
    }
    this.applyLayout()
  }

  applyLayout(width) {
    const style = this.style || defaultStyle
    for (let token of this.tokens) {
      token.setStyle(style)
    }
    const size = textLayout(this.tokens, style, { width })
    const newWidth = width === undefined ? size.width : width
    const newHeight = size.height

    this.layout.width = newWidth
    this.layout.height = newHeight
  }

  /**
   * Layouter API realisation to perform custom text layout
   */
  mudraLayout(style, width, height) {
    this.applyLayout(width)
    return this.layout
  }

  /**
   * Layouter API realisation to store layout size and use it for background drawing
   */
  setLayoutSize(dimension, value) {
    if (dimension === Dimension.WIDTH && this.layout.width !== value) {
      this.applyLayout(value)
    }
  }

  updateTexture() {
    const texture = this.memoizedCreateTexture(
      this.tokens,
      this.layout.width,
      this.layout.height,
      this.style,
      this.resolution,
    )
    if (texture !== this.texture) {
      this.texture.destroy(true)
      this.texture = texture
    }
  }

  _render(renderer) {
    this.updateTexture()
    super._render(renderer)
  }

  _renderCanvas(renderer) {
    this.updateTexture()
    super._renderCanvas(renderer)
  }

  destroy() {
    super.destroy(true)
  }
}

Text.measureText = measureText
Text.registerTextRule = registerTextRule
